import { CustomInput, FileInput, ReactSelect } from "../kits/Inputs/Inputs";
import { PlusCircle, EditIcon, DeleteIcon, CloseIcon } from "../kits/Icons";
import { useState } from "react";
import "./SingleProduct.scss";
import ColorSchema from "../kits/Color";
import { swalFunc } from "../../utils/helperFunction";
import CustomButton from "../kits/button/CustomButton";
import useAxios from "../../services/useAxios";
import ToastCustomize from "../kits/ToastCustomize";
export default function AddProductOption({
  answerTypes,
  optionType = "", //product, order

  productOptionsApi,
}) {
  const [optionData, setOptionData] = useState({
    title: "",
    file: "",
    answerType: "",
    answers: "",
  });
  const [optionAnswer, setOptionAnswer] = useState([]);
  const [validationTxt, setValidationTxt] = useState({
    title: "",
    answerTypes: "",
    answers: "",
  });
  const inputHandler = (name, value) => {
    setOptionData((prev) => {
      return { ...prev, [name]: value };
    });
  };
  const optionAnswerFunc = (value) => {
    setOptionData((prev) => {
      return { ...prev, answers: "" };
    });
    let temp = [
      ...optionAnswer,
      { name: value, index: optionAnswer.length + 1, edit: false },
    ];
    setOptionAnswer(temp);
  };
  const errorTxtFunc = (name, value) => {
    setValidationTxt((prev) => {
      return { ...prev, [name]: value };
    });
  };
  const validationFunc = () => {
    let validate = true;
    if (optionData.title == "") {
      errorTxtFunc("title", "عنوان آپشن را وارد کنید!");
      validate = false;
    } else {
      errorTxtFunc("title", "");
    }
    // if (optionData.answerType == "") {
    //   errorTxtFunc("answerTypes", "نوع پاسخ آپشن را وارد کنید!");
    //   validate = false;
    // } else {
    //   errorTxtFunc("answerTypes", "");
    // }
    if (optionData?.answerType?.value != 4 && optionAnswer.length == 0) {
      if (optionAnswer.length < 2) {
        errorTxtFunc("answers", "لطفا حداقل دو پاسخ وارد کنید!");
      } else {
        errorTxtFunc("answers", "لطفا حداقل یک پاسخ وارد کنید!");
      }
      validate = false;
    } else {
      errorTxtFunc("answers", "");
    }
    if (optionAnswer.findIndex((o) => o.edit == true) != -1)
      errorTxtFunc("answerInput", "لطفا پاسخ را تایید کنید!");
    return validate;
  };
  const deleteValueOption = (index) => {
    let temp = [...optionAnswer];
    temp.splice(index, 1);
    setOptionAnswer(temp);
  };
  const EditValueOption = (index, type, name, value) => {
    let temp = [...optionAnswer];
    if (type == "edit") {
      temp[index] = { ...temp[index], edit: true };
      setOptionAnswer(temp);
    } else if (type == "submit") {
      temp[index] = { ...temp[index], edit: false };
      setOptionAnswer(temp);
    } else if (type == "changeData") {
      temp[index] = { ...temp[index], [name]: value };
      setOptionAnswer(temp);
    }

    // inputHandler("answers", optionAnswer[index].name);
    // deleteValueOption(index);
  };
  const { loadingProductOption, execute: submitProductOption } = useAxios(
    "api/Insert_ProductOption"
  );
  const { loadingUpload, execute: uploadApi } = useAxios("api2/upload_img");
  const { loading, execute: submitOrderOption } = useAxios(
    "api/Insert_OptionOrder"
  );
  const submit = async () => {
    let img = 0;
    if (optionData.file != "") {
      await uploadApi({ file: optionData.file }).then((res) => {
        if (res.status == 1) {
          img = res.file_info[0].id;
        }
      });
    }
    if (optionType == "product") {
      submitProductOption({
        title: optionData.title,
        // type: optionData?.answerType?.value,
        file_id: img,
        params: JSON.stringify(optionAnswer),
      }).then((result) => {
        if (result.status == 1) {
          setOptionData({
            title: "",
            file: "",
            answerType: "",
            answers: "",
          });
          setOptionAnswer([]);

          productOptionsApi();
          ToastCustomize({
            mainText: "آپشن با موفقیت ثبت شد!",
            duration: 2000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
        } else {
          ToastCustomize({
            mainText: "متاسفانه مشکلی در ثبن پیش آمده است!",
            duration: 2000,
            toastType: "danger",
            color: "danger",
            position: "top-center",
            hasHeader: false,
          });
        }
      });
    } else if (optionType == "order")
      submitOrderOption({
        title: optionData.title,
        // type: optionData?.answerType?.value,
        type: 0,
        file_id: img,
        params: JSON.stringify(optionAnswer),
      }).then((result) => {
        if (result.status == 1) {
          setOptionData({
            title: "",
            file: "",
            answerType: "",
            answers: "",
          });
          setOptionAnswer([]);

          productOptionsApi();
          ToastCustomize({
            mainText: "آپشن با موفقیت ثبت شد!",
            duration: 2000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
        } else {
          ToastCustomize({
            mainText: "متاسفانه مشکلی در ثبن پیش آمده است!",
            duration: 2000,
            toastType: "danger",
            color: "danger",
            position: "top-center",
            hasHeader: false,
          });
        }
      });
  };
  console.log(optionData);
  return (
    <div className="add-product-option">
      <div className="w-50-input px-1 my-2">
        {" "}
        <CustomInput
          label="عنوان آپشن"
          inputSize="lg"
          type="text"
          inputContainer=""
          inputValue={optionData.title}
          onChangeFunc={(e) => inputHandler("title", e.target.value)}
          textErr={validationTxt.title}
        />
      </div>
      {/* <div className="w-30-input px-1 my-2">
        {" "}
        <ReactSelect
          title="نوع پاسخ"
          itemsList={answerTypes}
          inputContainer=""
          inputSize="lg"
          inputValue={optionData.answerType}
          onChangeFunc={(e) => inputHandler("answerType", e)}
          textErr={validationTxt.answerTypes}
        />{" "}
      </div> */}
      <div className="px-1 w-50-input my-2">
        {" "}
        <FileInput
          id={`add-new-file-option-${optionType}`}
          label="انتخاب عکس"
          txt="عکس آپشن مورد نظر..."
          onChangeFunc={(e) => inputHandler("file", e.target.files[0])}
        />
      </div>

      <div className="d-flex w-100 px-1 my-2">
        {" "}
        <CustomInput
          label="پاسخ:"
          inputSize="lg"
          type="text"
          inputContainer="w-90-input"
          inputValue={optionData.answers}
          onChangeFunc={(e) => inputHandler("answers", e.target.value)}
          textErr={validationTxt.answers}
        />
        <button
          className="p-0 btn d-flex flex-grow-1 add-btn"
          style={{ height: 80 }}
          onClick={() => {
            if (optionData.answers != "") optionAnswerFunc(optionData.answers);
          }}
        >
          {" "}
          <PlusCircle containerIconClassName="plusIconContainer" />
        </button>
      </div>
      {optionAnswer.length > 0 ? (
        <div className="w-100 mt-2">
          لیست پاسخهای آپشن {optionData.title}:
          <div className="d-flex flex-wrap mt-3">
            {optionAnswer.map((o, i) => {
              return (
                <div
                  className="d-flex me-5 my-2 align-items-center"
                  key={`option-list-${i}`}
                >
                  <CustomInput
                    label=""
                    inputSize="sm"
                    type="text"
                    inputContainer="w-input-edit"
                    inputValue={optionAnswer[i].name}
                    activate={o.edit ? "active" : "readOnly"}
                    plaintext={o.edit ? false : true}
                    onChangeFunc={(e) =>
                      EditValueOption(i, "changeData", "name", e.target.value)
                    }
                    textErr={o.edit ? validationTxt.answerInput : ""}
                  />

                  {o.edit ? (
                    <div
                      onClick={
                        () => EditValueOption(i, "submit")
                        // swalFunc(
                        //   `آیا از ثبت ${o.name} مطمئن هستید؟`,
                        //   () => ,
                        //   "warning"
                        // )
                      }
                    >
                      <CloseIcon
                        color={ColorSchema.success_custom}
                        iconClassName="cursor-pointer"
                      />
                    </div>
                  ) : (
                    <div
                      onClick={
                        () => EditValueOption(i, "edit")
                        // swalFunc(
                        //   `آیا از ویرایش ${o.name} مطمئن هستید؟`,
                        //   () => EditValueOption(i, "edit"),
                        //   "warning"
                        // )
                      }
                    >
                      <EditIcon
                        color={ColorSchema.primary_custom}
                        iconClassName="cursor-pointer"
                      />
                    </div>
                  )}

                  <div
                    onClick={() =>
                      swalFunc(
                        `آیا از حذف ${o.name} مطمئن هستید؟`,
                        () => deleteValueOption(i),
                        "warning"
                      )
                    }
                  >
                    {" "}
                    <DeleteIcon
                      iconClassName="cursor-pointer"
                      color={ColorSchema.danger_custom}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="d-flex justify-content-end w-100">
        {" "}
        <div
          onClick={() => {
            if (validationFunc()) {
              submit();
            }
          }}
        >
          <CustomButton color="success">افزودن آپشن جدید </CustomButton>
        </div>
      </div>
    </div>
  );
}
